import { useContext } from "react";
import SelectClientesContext from "../context/selectClientesContext";

const useSelectClientes = () => useContext(SelectClientesContext);

export default useSelectClientes;
